/**
 * O link do suporte técnico no WhatsApp — fonte ÚNICA.
 *
 * Dois consumidores desenham o MESMO destino, e os dois são o cartão
 * (`suporte-whatsapp-card.vue`): abaixo do composer no estado vazio e no pé do
 * painel da conversa. O link do rodapé do composer (`suporte-whatsapp.vue`)
 * era o terceiro e SAIU em 17/09/2026 — o helper continua separado do
 * componente porque montar a URL dentro dele faria a próxima superfície
 * recopiá-la, e a cópia divergiria justamente na mensagem pré-preenchida, que
 * é o que o suporte lê para saber de onde a pessoa veio.
 */
import { TECH_CONTACT_NUMBER } from '@constants/Text'
import { whatsApp } from '@constants/URL'
import { SUPORTE_WHATSAPP } from '@modules/aawz-intelligence-v2/constants/Text'

export function linkDoSuporte() {
  return whatsApp.link(SUPORTE_WHATSAPP.mensagem, TECH_CONTACT_NUMBER)
}
